import React, { useEffect, useState, useContext } from 'react';

const LanguageContext = React.createContext();
const LANGUAGE_STORAGE_KEY = 'selectedLanguage';

export const useLanguageContext = () => useContext(LanguageContext);

function getStoredLanguage() {
	try {
		return localStorage.getItem(LANGUAGE_STORAGE_KEY);
	} catch {
		return null;
	}
}

function storeLanguage(language) {
	try {
		localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
	} catch {
		// Keep the in-memory language when browser settings deny storage access.
	}
}

function getBrowserLocales(options = {}) {
	const defaultOptions = {
		languageCodeOnly: false,
	};

	const opt = {
		...defaultOptions,
		...options,
	};

	const browserLocales =
		navigator.languages === undefined
		? [navigator.language]
		: navigator.languages;

	if (!browserLocales) {
		return undefined;
	}

	return browserLocales.map(locale => {
		const trimmedLocale = locale.trim();
		return opt.languageCodeOnly
			? trimmedLocale.split(/-|_/)[0]
			: trimmedLocale;
	});
}

function getDefaultLocale(browserLocale) {
	const fallbackLanguage = 'en';
	const supportedLanguages = ['en', 'fr', 'es'];

	if (supportedLanguages.indexOf(browserLocale) > -1) {
		return browserLocale;
	}

	return fallbackLanguage;
}

export default function LanguageContextProvider({ children }) {
	const browserLanguages = getBrowserLocales({languageCodeOnly: true}) || [];
	const defaultLocale = getDefaultLocale(browserLanguages[0]);
	const [language, setLanguage] = useState(() => getStoredLanguage() || defaultLocale);

	const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    storeLanguage(newLanguage);
  };

	useEffect(() => {
    document.documentElement.lang = language || 'en';
  }, [language]);

	return (
		<LanguageContext.Provider value={{ language, changeLanguage }}>
			{children}
		</LanguageContext.Provider>
	);
}
